import React from 'react';
import {Layout} from 'antd';

const {Content} = Layout;


const Folha = (props) => {
    return(<Content
        className="site-layout-background"
        style={{
          padding: 24,
          margin: 23,
          
        }}
      >
          {props.children}
      </Content>);
}

export {Folha}